import { TFunction } from 'i18next';
import { object, string } from 'yup';

export const selectSearchOptionValidation = (t: TFunction) =>
  object({
    label: string().required(t('general.required')),
    value: string().required(t('general.required')),
  });

export const selectSearchOptionOptionalValidation = () =>
  object({
    label: string().optional(),
    value: string().optional(),
  });
